module.exports = __webpack_public_path__ + "static/media/nuces-logo.8319c1f6.png";